module.exports = __webpack_public_path__ + "media/images/events-share-5c25a6185f3d7ce838cb7cd564945b48.png";